import { getURLParameter } from "../../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameModel from "../model/GameModel";
import ScenarioState from "../model/ScenarioState";
import GameFlowEvent from "./GameFlowEvent";


export default class StartGameCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, gameModel) {
        super(dispatcher);
        this._gameModel = gameModel;
    }

    execute(event) {            
        const isAnyEpisodeStarted = !!this._gameModel.scenarioStates.find(scenarioState => scenarioState.state == ScenarioState.STATE_STARTED);

        if (isAnyEpisodeStarted || getURLParameter("skiptutorial") === "1") {
            this.dispatch(GameFlowEvent.TUTORIAL_COMPLETED);
        } else {
            this.gotoScreen(SkinKeys.TUTORIAL_SCREEN);
        }
    }
}